import { COMPANY, EDIT, FUND } from 'common/constants/user';
import { CompanyByFirm } from 'common/types/company';
import { Fund } from 'common/types/fund';
import { Permission } from 'pages/UserPermissions/common/types';
import { getNumberValue } from 'utilities';

export interface UserPermissions {
  user_id?: number;
  role_type?: number;
  permissions: Permission[];
}

type GetAllPotentialPermissionsProps = {
  userPermissionsToSave: UserPermissions;
  fundList: Fund[];
  companyList: CompanyByFirm[];
};

// This function will be used when we implement a custom role (one that has a mix of permissions)
export const getAllPotentialPermissions = ({
  userPermissionsToSave,
  fundList,
  companyList,
}: GetAllPotentialPermissionsProps) => {
  const allMissingFundsAndCompsPermissions: Permission[] = [];
  fundList.forEach(fund => {
    // Only include funds that are not already in the selected user's permissions
    const fundPermissionIds = userPermissionsToSave?.permissions
      ?.filter(
        perm => !perm.remove_permission && perm?.feature_object?.object_type === FUND && perm.access_type === EDIT
      )
      .map(perm => perm?.feature_object?.object_id);
    if (!fundPermissionIds?.includes(fund.id)) {
      allMissingFundsAndCompsPermissions.push({
        id: 0,
        feature_object: {
          feature: null,
          object_type: FUND,
          object_id: fund.id as number,
        },
        access_type: EDIT,
        remove_permission: false,
        firm_role: null,
      });
    }
  });
  companyList.forEach(company => {
    // Only include companies that are not already in the selected user's permissions
    const companyPermissionIds = userPermissionsToSave?.permissions
      ?.filter(
        perm => !perm.remove_permission && perm?.feature_object?.object_type === COMPANY && perm.access_type === EDIT
      )
      .map(perm => perm?.feature_object?.object_id);
    if (!companyPermissionIds?.includes(getNumberValue(company.company_id))) {
      allMissingFundsAndCompsPermissions.push({
        id: 0,
        feature_object: {
          feature: null,
          object_type: COMPANY,
          object_id: getNumberValue(company.company_id),
        },
        access_type: EDIT,
        remove_permission: false,
        firm_role: null,
      });
    }
  });

  return allMissingFundsAndCompsPermissions;
};
